/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_action__save_close = /** @type {(inputs: {}) => string} */ () => {
	return `Speichern und schließen`
};

const en_action__save_close = /** @type {(inputs: {}) => string} */ () => {
	return `Save and close`
};

const es_action__save_close = /** @type {(inputs: {}) => string} */ () => {
	return `Guardar y cerrar`
};

const fr_action__save_close = /** @type {(inputs: {}) => string} */ () => {
	return `Sauvegarder et fermer`
};

const it_action__save_close = /** @type {(inputs: {}) => string} */ () => {
	return `Salvare e chiudere`
};

const nl_action__save_close = /** @type {(inputs: {}) => string} */ () => {
	return `Opslaan en sluiten`
};

const pt_action__save_close = /** @type {(inputs: {}) => string} */ () => {
	return `Guardar e fechar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const action__save_close = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.action__save_close(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("action__save_close", locale)
	if (locale === "de") return de_action__save_close(inputs)
	if (locale === "en") return en_action__save_close(inputs)
	if (locale === "es") return es_action__save_close(inputs)
	if (locale === "fr") return fr_action__save_close(inputs)
	if (locale === "it") return it_action__save_close(inputs)
	if (locale === "nl") return nl_action__save_close(inputs)
	return pt_action__save_close(inputs)
};